import React, {useState} from "react";
import FeatherIcon from "feather-icons-react";
import {useTranslation} from "react-i18next";
import useAxios from "../utils/useAxios";
import PreImage from "./PreImage";
import { patchTournamentListCache } from "../utils/patchTournamentListCache";

const BannerUpload = ({id, image, width, height, setImage, loading}) => {
    const {t} = useTranslation();
    const api = useAxios();
    const [uploading, setUploading] = useState(false);

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formDataToSend = new FormData();
        formDataToSend.append("image", file);

        setUploading(true);
        try {
            const response = await api.patch(
                `/api/v1.0/tournaments/${id}/`,
                formDataToSend
            );
            setImage({
                url: response.data.image,
                width: response.data.width,
                height: response.data.height,
            });
            // Same reasoning as TournamentInformationForm.js's own call -
            // without it, главная's scroll-restore snapshot keeps the
            // pre-upload banner (or no banner at all) for up to 10 minutes.
            patchTournamentListCache(id, {
                image: response.data.image,
                width: response.data.width,
                height: response.data.height,
            });
        } catch (error) {
            console.error("Image upload error", error);
        } finally {
            setUploading(false);
        }
    };

    const handleRemoveImage = async () => {
        const confirmed = window.confirm(t("Are you sure you want to delete the image?"));
        if (confirmed) {
            const formDataToSend = new FormData();
            formDataToSend.append("image", "");

            setUploading(true);
            try {
                await api.patch(`/api/v1.0/tournaments/${id}/`, formDataToSend);
                setImage(null);
                patchTournamentListCache(id, { image: null, width: null, height: null });
            } catch (error) {
                console.error("Image remove error", error);
            } finally {
                setUploading(false);
            }
        }
    };

    return (
        <div className="content_page banner-container">
            <label>{t("Image")}</label>
            {image && <FeatherIcon icon="x" onClick={handleRemoveImage} />}
            <div className="banner-preview">
                {

                    loading ? <>
                        </> :
                    uploading ? (<>
                            <FeatherIcon icon="loader"/>
                        </>)
                        :
                    image ? (
                    <>
                        <PreImage
                            src={image?.url || image}
                            width={image?.width || width}
                            height={image?.height || height}
                        />
                    </>
                ) : (
                    <div>
                        <FeatherIcon icon="image"/>
                        <p>{t("Supported formats")}:
                            <br/>
                            JPG, PNG, GIF</p>
                    </div>
                )}
                <input
                    type="file"
                    name="image"
                    accept="image/png, image/jpeg, image/gif"
                    onChange={handleImageChange}
                    style={{position: "absolute", width: "100%", height: "100%", opacity: 0, cursor: "pointer"}}
                />
            </div>
        </div>
    );
};

export default BannerUpload;
